import * as React from 'react';
import './App.css';
import Landing from './pages/landing';



class App extends React.Component {
  public render(): JSX.Element {
    return (
      <div className="App">
        <Landing />
      </div>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.tsx